import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    allocation: {
      id: 'pages.orderProcessSection.processing.allocation',
      defaultMessage: 'Allocation',
      description: 'Label of the processing property allocation',
    },
    capture: {
      id: 'pages.orderProcessSection.processing.capture',
      defaultMessage: 'Capture',
      description: 'Label of the processing property allocation',
    },
    confirm: {
      id: 'pages.orderProcessSection.processing.confirm',
      defaultMessage: 'Confirm',
      description: 'Label of the processing property confirm',
    },
    fulfilment: {
      id: 'pages.orderProcessSection.processing.fulfilment',
      defaultMessage: 'Fulfilment',
      description: 'Label of the processing property fulfilment',
    },
  },
  processingOptions: {
    auto: {
      id: 'pages.orderProcessSection.processingOptions.auto',
      defaultMessage: 'Automatically',
      description: 'Label of the processing option auto',
    },
    manual: {
      id: 'pages.orderProcessSection.processingOptions.manual',
      defaultMessage: 'manual',
      description: 'Label of the processing option manual',
    },
    none: {
      id: 'pages.orderProcessSection.processingOptions.none',
      defaultMessage: 'None',
      description: 'Label of the processing option none',
    },
  },
};

export default defineMessages(translations);
